import { render, staticRenderFns } from "./TradeDetailsTab.vue?vue&type=template&id=4f53cc69&"
import script from "./TradeDetailsTab.vue?vue&type=script&lang=js&"
export * from "./TradeDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./TradeDetailsTab.vue?vue&type=style&index=0&id=4f53cc69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports